import { render, staticRenderFns } from "./AddUpdateRestaurant.vue?vue&type=template&id=5f748386&scoped=true&"
import script from "./AddUpdateRestaurant.vue?vue&type=script&lang=js&"
export * from "./AddUpdateRestaurant.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f748386",
  null
  
)

export default component.exports